<template>
    <el-dialog title="分组明细" :visible.sync="isVisible" width="80%" @close="handleClose">
        <avue-crud :option="tableOption" :data="tableData" :table-loading="tableLoading" :page="page" ref="crud"
            @search-change="searchChange" @refresh-change="refreshChange(page)" @size-change="pageSizeChange"
            @current-change="pageChange" @addBtn="handleAdd">
            <template slot="menuLeft">
                <el-button type="text" icon="el-icon-plus" size="small" plain @click.stop="handleAdd">新增</el-button>
                <!-- <el-button type="text" icon="el-icon-edit" size="small" @click="handleTransfer">转移</el-button> -->
                <!-- 删除 -->
                <el-button type="text" icon="el-icon-delete" size="small" @click="handleDelete">删除</el-button>
            </template>
            <template slot-scope="scope" slot="menu">
                <!-- 转移 -->
                <el-button type="text" icon="el-icon-edit" size="small"
                    @click="handleTransfer(scope.row)">转移</el-button>
                <!-- 删除 -->
                <el-button type="text" icon="el-icon-delete" size="small"
                    @click="handleDelete(scope.row)">删除</el-button>
            </template>
        </avue-crud>
        <!-- 新增工程师对话框 -->
        <el-dialog title="新增工程师" :visible.sync="addDialogVisible" width="500px" @close="addDialogVisible = false"
            append-to-body>
            <el-form ref="addFormRef" :model="addForm" label-width="100px">
                <el-form-item label="选择工程师" prop="userId">
                    <el-select v-model="addForm.userId" placeholder="请选择工程师" filterable remote :remote-method="remoteSearchAgent" style="width: 100%">
                        <el-option v-for="engineer in engineerList" :key="engineer.id" :label="engineer.realName" :value="engineer.id"
                            @click.native="handleAgentChange(engineer)"></el-option>
                    </el-select>
                </el-form-item>
                <!-- <el-form-item label="工程师名称" prop="userName">
                        <el-input v-model="addForm.userName" placeholder="工程师名称" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="工程师电话" prop="userMobile">
                        <el-input v-model="addForm.userMobile" placeholder="工程师电话" disabled></el-input>
                    </el-form-item> -->
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="addDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="confirmAdd">确定</el-button>
            </div>
        </el-dialog>
        <!-- 转移分组对话框 -->
        <el-dialog title="转移到分组" :visible.sync="transferDialogVisible" width="500px" append-to-body
            @close="transferDialogVisible = false">
            <el-form ref="transferFormRef" :model="transferForm" label-width="100px">
                <el-form-item label="目标分组" prop="targetGroupId">
                    <el-select v-model="transferForm.targetGroupId" placeholder="请选择目标分组">
                        <el-option v-for="group in groupList" :key="group.id" :label="group.groupName"
                            :value="group.id"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="transferDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="confirmTransfer">确定</el-button>
            </div>
        </el-dialog>
    </el-dialog>
</template>
<script>
import { getGroupDetails, addGroupDetail, deleteGroupDetails, transferGroupDetail, findAgent, findUser } from '@/api/sales/accountGroup';
export default {
    name: 'GroupDetails',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        groupId: {
            type: [Number, String],
            required: true
        }
    },
    watch: {
        visible(newVal) {
            this.isVisible = newVal;
            if (newVal && this.groupId) {
                this.handleDetailList();
            }
        },
        groupId(newVal) {
            if (this.visible && newVal) {
                this.handleDetailList();
            }
        }
    },
    data() {
        return {
            isVisible: this.visible,
            tableOption: {
                align: 'center',
                menuAlign: 'center',
                headerAlign: 'center',
                border: true,
                expand: false,
                stripe: false,
                showHeader: true,
                index: false,
                selection: true,
                menu: true,
                menuWidth: 200,
                page: true,
                addBtn: false,
                editBtn: false,
                delBtn: false,
                viewBtn: false,
                menuType: 'text',
                column: [
                    {
                        label: 'ID',
                        prop: 'id',
                        type: 'input',
                        hide: true
                    },
                    {
                        label: '工程师ID',
                        prop: 'userId',
                        type: 'input',
                        hide: true
                    },
                    {
                        label: '工程师名称',
                        prop: 'userName',
                        type: 'input',
                        search: true
                    },
                    /* {
                        label: '工程师电话',
                        prop: 'userMobile',
                        type: 'input',
                        search: true
                    }, */
                    {
                        label: '创建时间',
                        prop: 'createTime',
                        type: 'datetime',
                        format: 'yyyy-MM-dd HH:mm:ss',
                        // valueFormat: 'timestamp'
                    }
                ]
            },
            tableData: [],
            tableLoading: false,
            page: {
                total: 0,
                currentPage: 1,
                pageSize: 10
            },
            // 保存要转移的记录
            transferSelections: [],
            // 新增工程师表单
            addForm: {
                userId: '',
                userName: '',
                userMobile: ''
            },
            addDialogVisible: false,
            // 转移分组表单
            transferForm: {
                targetGroupId: ''
            },
            transferDialogVisible: false,
            // 可选分组列表
            groupList: [],
            // 工程师列表
            engineerList: [],
            // 工程师搜索关键词
            engineerSearchKeyword: ''
        };
    },
    methods: {
        handleDetailList() {
            if (!this.groupId) return;
            this.tableLoading = true;
            const params = {
                groupId: this.groupId,
                page: this.page.currentPage,
                size: this.page.pageSize
            };
            getGroupDetails(params)
                .then(res => {
                    if (res.code === '200') {
                        const data = JSON.parse(res.data);
                        console.log('groupDetails.vue ~ line: 183 ~ data ->', data);
                        this.tableData = data.rows || [];
                        this.page.total = data.total || 0;
                    } else {
                        this.tableData = [];
                        this.page.total = 0;
                        this.$message.error('获取分组明细失败');
                    }
                })
                .catch(error => {
                    console.log('groupDetails.vue ~ line: 190 ~ error ->', error);
                    this.tableData = [];
                    this.page.total = 0;
                    this.$message.error('获取分组明细异常');
                })
                .finally(() => {
                    this.tableLoading = false;
                });
        },
        pageChange(page) {
            this.page.currentPage = page;
            this.handleDetailList();
        },
        pageSizeChange(pageSize) {
            this.page.pageSize = pageSize;
            this.handleDetailList();
        },
        searchChange(params) {
            this.page.currentPage = 1;
            const searchParams = {
                groupId: this.groupId,
                page: 1,
                size: this.page.pageSize
            };
            // 添加搜索参数
            if (params.userName) {
                searchParams.userName = params.userName;
            }
            if (params.userMobile) {
                searchParams.userMobile = params.userMobile;
            }
            this.tableLoading = true;
            getGroupDetails(searchParams)
                .then(res => {
                    if (res.code === '200') {
                        const data = JSON.parse(res.data);
                        this.tableData = data.rows || [];
                        this.page.total = data.total || 0;
                    } else {
                        this.tableData = [];
                        this.page.total = 0;
                        this.$message.error('搜索分组明细失败');
                    }
                })
                .catch(error => {
                    console.log('groupDetails.vue ~ line: 235 ~ error ->', error);
                    this.tableData = [];
                    this.page.total = 0;
                    this.$message.error('搜索分组明细异常');
                })
                .finally(() => {
                    this.tableLoading = false;
                });
        },
        refreshChange(page) {
            this.page.currentPage = page.currentPage;
            this.page.pageSize = page.pageSize;
            this.handleDetailList();
        },
        handleClose() {
            this.$emit('close');
        },
        // 处理新增按钮点击
        handleAdd() {
            this.addForm = {
                userId: '',
                userName: '',
                userMobile: ''
            };
            this.engineerList = [];
            this.addDialogVisible = true;
        },
        // 远程搜索工程师
        remoteSearchAgent(query) {
            if (query === '') {
                this.engineerList = [];
                return;
            }
            
            const params = {
                type: "JOINS_ENGINEER",
                mobile: query
            };
            
            findAgent(params)
                .then(res => {
                    console.log('groupDetails.vue ~ line: 281 ~ res ->', res);
                    if (res.code == '200') {
                        const data = JSON.parse(res.data);
                        console.log('groupDetails.vue ~ line: 283 ~ data ->', data);
                        this.engineerList = data || [];
                    } else {
                        this.$message.error('搜索工程师失败');
                    }
                })
                .catch(error => {
                    console.log('groupDetails.vue ~ line: 283 ~ error ->', error);
                    this.$message.error('搜索工程师异常');
                });
        },
        // 处理工程师选择
        handleAgentChange(engineer) {
            console.log('groupDetails.vue ~ line: 297 ~ engineer ->', engineer);
            if (engineer) {
                this.addForm.userId = engineer.id;
                this.addForm.userName = engineer.realName;
                this.addForm.userMobile = engineer.mobile || '';
                this.addForm.groupId = this.groupId;
            } else {
                this.addForm.userId = '';
                this.addForm.userName = '';
                this.addForm.userMobile = '';
            }
        },

        // 确认新增分组明细
        confirmAdd() {
            // 验证表单
            if (!this.addForm.userId || !this.addForm.userName) {
                this.$message.error('请填写完整的工程师信息');
                return;
            }
            const data = {
                userId: this.addForm.userId,
                groupId: this.groupId,
                userName: this.addForm.userName,
                userMobile: this.addForm.userMobile
            };
            this.tableLoading = true;
            addGroupDetail(data)
                .then(res => {
                    if (res.code === '200') {
                        this.$message.success('新增成功');
                        this.addDialogVisible = false;
                        this.handleDetailList(); // 重新加载列表
                    } else {
                        this.$message.error('新增失败：' + (res.message || '未知错误'));
                    }
                })
                .catch(error => {
                    console.log('groupDetails.vue ~ line: 327 ~ error ->', error);
                    this.$message.error('新增分组明细异常');
                })
                .finally(() => {
                    this.tableLoading = false;
                });
        },
        // 处理删除按钮点击
        handleDelete(row) {
            let selections;
            // 如果传入了行数据，则为单个删除
            if (row && row.id) {
                selections = [row];
            } else {
                // 否则为批量删除
                selections = this.$refs.crud.$refs.table.selection;
                if (!selections || selections.length === 0) {
                    this.$message.warning('请先选择要删除的记录');
                    return;
                }
            }
            this.$confirm('确定要删除选中的 ' + selections.length + ' 条记录吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.confirmDelete(selections);
            }).catch(() => {
                this.$message.info('已取消删除');
            });
        },
        // 确认删除分组明细
        confirmDelete(selections) {
            const ids = selections.map(item => item.id).join(',');
            this.tableLoading = true;
            deleteGroupDetails(ids)
                .then(res => {
                    if (res.code === '200') {
                        this.$message.success('删除成功');
                        this.handleDetailList(); // 重新加载列表
                    } else {
                        this.$message.error('删除失败：' + (res.message || '未知错误'));
                    }
                })
                .catch(error => {
                    console.log('groupDetails.vue ~ line: 371 ~ error ->', error);
                    this.$message.error('删除分组明细异常');
                })
                .finally(() => {
                    this.tableLoading = false;
                });
        },
        // 处理转移按钮点击
        handleTransfer(row) {
            // 保存当前要转移的记录（可能是单行或多行选中的）
            if (row && row.id) {
                // 如果传入了行数据，则为单个转移
                this.transferSelections = [row];
            } else {
                // 否则尝试获取批量选中的记录
                this.transferSelections = this.$refs.crud.$refs.table.selection
                if (!this.transferSelections || this.transferSelections.length === 0) {
                    this.$message.warning('请选择要转移的记录');
                    return;
                }
            }
            // 获取分组列表
            this.getGroupList();
            this.transferForm = {
                targetGroupId: ''
            };
            this.transferDialogVisible = true;
        },
        // 获取分组列表
        getGroupList() {
            findUser({ page: 1, size: '' }) // 获取所有分组，与index.vue保持一致使用findUser
                .then(res => {
                    if (res.code === '200') {
                        const data = JSON.parse(res.data);
                        this.groupList = data.rows || [];
                    } else {
                        this.$message.error('获取分组列表失败');
                    }
                })
                .catch(error => {
                    console.log('error', error);
                    this.$message.error('获取分组列表异常');
                });
        },
        // 确认转移分组明细
        confirmTransfer() {
            if (!this.transferForm.targetGroupId) {
                this.$message.error('请选择目标分组');
                return;
            }
            if (!this.transferSelections || this.transferSelections.length === 0) {
                this.$message.warning('请选择要转移的记录');
                return;
            }
            // 处理多个转移
            this.tableLoading = true;
            try {
                // 获取选中的ID列表，添加安全检查
                const ids = this.transferSelections
                    .filter(item => item && item.id !== undefined)
                    .map(item => item.id)
                    .join(',');
                if (!ids) {
                    throw new Error('没有获取到有效的记录ID');
                }
                const data = {
                    id: ids,  // 传递多个ID
                    groupId: this.transferForm.targetGroupId
                };
                transferGroupDetail(data)
                    .then(res => {
                        if (res.code === '200') {
                            this.$message.success('转移成功');
                            this.transferDialogVisible = false;
                            this.handleDetailList(); // 重新加载列表
                        } else {
                            this.$message.error('转移失败：' + (res.message || '未知错误'));
                        }
                    })
                    .catch(error => {
                        console.log('groupDetails.vue ~ line: 457 ~ error ->', error);
                        this.$message.error('转移分组明细异常');
                    })
                    .finally(() => {
                        this.tableLoading = false;
                    });
            } catch (error) {
                this.$message.error('处理转移数据异常：' + error.message);
                this.tableLoading = false;
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.el-dialog__body {
    padding: 15px;
}

/* 表格样式优化 */
.avue-crud__header {
    padding: 10px 0;
}
</style>